export * from './dependant.component';
